import { createFileRoute } from '@tanstack/react-router'
import { MouvementForm } from '@features/stock/components/MouvementForm'
import { usePermissions } from '@lib/hooks/usePermissions'
import { requirePermission } from '@lib/permissions/guards'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'

export const Route = createFileRoute('/_app/stock/mouvements/create')({
  beforeLoad: ({ context }) => {
    requirePermission(PERMISSIONS.STOCK.MOVEMENTS.CREATE, context)
  },
  component: CreateMouvementComponent,
})

function CreateMouvementComponent() {
  const { canCreate } = usePermissions()
  
  if (!canCreate('stock.movements.create')) {
    return <div className="p-6">Accès non autorisé</div>
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Nouveau Mouvement</h1>
      <MouvementForm />
    </div>
  )
}
